import type { JSX } from "react";
import { Stack } from "@genius-tracker/design-system";
import { useLocale } from "@genius-tracker/i18n/react";
import { EmailDeliveryContent } from "../../../email-delivery/EmailDeliveryPage.js";
import { useGtccHeadTabs } from "../control/HeadTabsContext.js";

/**
 * L-GTCC-35 — complete email-delivery diagnostics in the GTCC mono-deck.
 *
 * The operational content is shared with gtcc1 so status/provider/template/
 * recipient filters, report correlation, lifecycle truth and pagination cannot
 * drift. GtccShell owns the platform-owner gate around this view; the API keeps
 * its independent platform-owner guard on GET /v1/admin/email-deliveries.
 */
export function GtccEmailDeliveriesView(): JSX.Element {
  const { t } = useLocale();
  const headTabs = useGtccHeadTabs();

  return (
    <Stack gap={4} style={{ padding: "var(--gt-sys-space-5)" }} data-testid="gtcc-view-edel">
      <Stack gap={1}>
        <h2 style={{ margin: 0, fontSize: "var(--gt-sys-font-size-lg)" }}>
          {t("admin.email_delivery.title")}
        </h2>
        <p style={{ margin: 0, color: "var(--gt-sys-text-muted)" }}>
          {t("admin.email_delivery.subtitle")}
        </p>
        <p
          style={{
            margin: 0,
            color: "var(--gt-sys-text-muted)",
            fontSize: "var(--gt-sys-font-size-xs)",
          }}
        >
          {t("admin.email_delivery.read_only_hint")}
        </p>
        <p
          style={{
            margin: 0,
            color: "var(--gt-sys-text-muted)",
            fontSize: "var(--gt-sys-font-size-xs)",
          }}
          data-testid="gtcc-email-delivery-status-truth"
        >
          {t("admin.email_delivery.status_truth_note")}
        </p>
      </Stack>

      {headTabs}

      <EmailDeliveryContent queryScope="gtcc" />
    </Stack>
  );
}
